import { Button, Classes, InputGroup, Tooltip } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import classnames from "classnames";
import { getIn } from "formik";
import { FGCustomInput } from "nsitools-react";
import * as React from "react";
import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales/ETLCodes";

export interface IFGPasswordInputProps {
  name: string;
  label: string;
  readonly?: boolean;
  placeholder?: string;
}

export const FGPasswordInput: React.FunctionComponent<IFGPasswordInputProps> = ({
  name,
  label,
  readonly = false,
  placeholder,
}) => {
  const { t } = useTl();
  const [showPassword, setShowPassword] = React.useState(false);

  const togglePasswordVisibility = React.useCallback(() => {
    setShowPassword((prev) => !prev);
  }, []);

  const lockButton = React.useMemo(
    () => (
      <Tooltip content={showPassword ? t(ETLCodes.HidePassword) : t(ETLCodes.ShowPassword)}>
        <Button
          icon={showPassword ? IconNames.EYE_OFF : IconNames.EYE_OPEN}
          minimal={true}
          onClick={togglePasswordVisibility}
          tabIndex={-1}
        />
      </Tooltip>
    ),
    [showPassword, t, togglePasswordVisibility]
  );

  return (
    <FGCustomInput label={label} name={name}>
      {(ctx) =>
        ctx.editMode && !readonly ? (
          <>
            <InputGroup
              type={showPassword ? "text" : "password"}
              value={getIn(ctx?.formik?.values, name) ?? ""}
              onChange={(e) => ctx.formik?.setFieldValue(name, e.target.value)}
              onBlur={() => ctx.formik?.setFieldTouched(name, true)}
              placeholder={placeholder}
              rightElement={lockButton}
              intent={ctx.formik?.errors?.[name] ? "danger" : "none"}
            />
            {ctx.formik?.errors?.[name] && (
              <div
                className={classnames(
                  Classes.FORM_HELPER_TEXT,
                  Classes.INTENT_DANGER
                )}
                style={{ color: "#c23030" }}
              >
                {ctx.formik?.errors?.[name] as string}
              </div>
            )}
          </>
        ) : (
          <div>••••••••</div>
        )
      }
    </FGCustomInput>
  );
};
